import * as React from 'react';
import { useEffect } from 'react';
import { devWarning } from '../../wui-core/src/warning';
import { LocaleProviderProps } from './iLocale';
import LocaleContext from './locale-context';

export const ANT_MARK = 'internalMark';
export const Locale = {
    locale: "zh-CN",
};

const LocaleProvider: React.FC<Partial<LocaleProviderProps>> = ({
    locale = {},
    children,
    _ANT_MARK__,
}) => {
    useEffect(() => {
        devWarning(
            _ANT_MARK__ === ANT_MARK,
            'LocaleProvider',
            '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead',
        );
    }, []);

    const __locale = typeof locale === 'string' ? { locale } : locale || {};

    return (
        <LocaleContext.Provider value={{ ...__locale, exist: true }}>
            {children}
        </LocaleContext.Provider>
    );
};

export default LocaleProvider;